import React from 'react';
import PropTypes from 'prop-types';
import Card from '../Card';
import CardInner from '../CardInner';
import CardContent from '../CardContent';
import CardContentImage from '../CardContentImage';
import CardContentBody from '../CardContentBody';
import CardContentImagePlay from '../CardContentImagePlay';
import CardReadMore from '../CardReadMore';
import CardContentImageDate from '../CardContentImageDate';

/**
 * A component for displaying stacked content
 */
function StackedCard({
  width,
  colour,
  size,
  title,
  imageRight,
  readMoreHref,
  readMoreTitle,
  noLink,
  href,
  linkTitle,
  target,
  className,
  source,
  alt,
  time,
  date,
  meta,
  headingTag,
  children
}) {
  return (
    <Card
      type={'stacked'}
      width={width}
      colour={colour}
      size={size}
      imageRight={imageRight}
      hasReadMore={readMoreHref}
      noLink={noLink}
      link={!!href}
      className={className}
    >
      <CardInner href={href} title={linkTitle} target={target}>
        <CardContent>
          <CardContentImage alt={alt} source={source} ariaHidden={true}>
            {time && <CardContentImagePlay time={time} />}
            {date && <CardContentImageDate date={date} />}
          </CardContentImage>
          <CardContentBody title={title} meta={meta} headingTag={headingTag}>
            {children}
            {readMoreHref && (
              <div>
                <CardReadMore href={readMoreHref} title={readMoreTitle || title} />
              </div>
            )}
          </CardContentBody>
        </CardContent>
      </CardInner>
    </Card>
  );
}

StackedCard.propTypes = {
  /**
   * The card width
   */
  width: PropTypes.arrayOf(['small', 'medium', 'large']),
  /**
   * The card colour
   */
  colour: PropTypes.string,
  /**
   * The card size
   */
  size: PropTypes.string,
  /**
   * The card title
   */
  title: PropTypes.string,
  /**
   * The image right flag
   */
  imageRight: PropTypes.bool,
  /**
   * The read more link
   */
  readMoreHref: PropTypes.string,
  /**
   * The read more link title
   */
  readMoreTitle: PropTypes.string,
  /**
   * The no link flag
   */
  noLink: PropTypes.bool,
  /**
   * The card link
   */
  href: PropTypes.string,
  /**
   * The card link title
   */
  linkTitle: PropTypes.string,
  /**
   * The card link target
   */
  target: PropTypes.string,
  /**
   * The card classes
   */
  className: PropTypes.string,
  /**
   * The card image source
   */
  source: PropTypes.string,
  /**
   * The card image alt text
   */
  alt: PropTypes.string,
  /**
   * The card time value
   */
  time: PropTypes.string,
  /**
   * The card date value
   */
  date: PropTypes.string,
  /**
   * The card metadata
   */
  meta: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  /**
   * The card heading tag element
   */
  headingTag: PropTypes.string,
  /**
   * The nested children
   */
  children: PropTypes.node
};

export default StackedCard;
